const _ = require('./enum');

module.exports = {
  [_.FIDO]: { id: _.FIDO, label: 'FIDO' },
  [_.GUEST]: { id: _.GUEST, label: 'Guest' },
  [_.MERCHANT_CREDENTIALS]: { id: _.MERCHANT_CREDENTIALS, label: 'Merchant credentials' },
  [_.THIRD_PARTY]: { id: _.THIRD_PARTY, label: 'Third party' },
  [_.OTHER]: { id: _.OTHER, label: 'Other' },
};
